import { COMPANY } from "../lib/content";

const SECTIONS = [
    {
        title: "1. Overview",
        body: `This Refund & Cancellation Policy explains how cancellations and refunds work for the services of ${COMPANY.legal} ("WorkAssign AI"). By purchasing a recharge or subscription, you agree to this policy.`,
    },
    {
        title: "2. Small Business Recharge (Pay-As-You-Go)",
        body: "The ₹499 Small Business plan is a prepaid recharge, not a subscription. Balance is deducted only on real, billable AI usage. Unused recharge balance remains in your account and does not expire while your account is active. Recharges once used (any portion consumed) are non-refundable; unused balance may be refunded on request within 7 days of recharge, after deducting any payment-gateway charges.",
    },
    {
        title: "3. Enterprise Subscription",
        body: "Enterprise Premium is a monthly subscription billed in advance. You may cancel at any time — cancellation takes effect at the end of the current billing cycle, and no further charges are made. Amounts already billed for the active cycle are non-refundable except where required by law or agreed in writing.",
    },
    {
        title: "4. Service Non-Delivery",
        body: "If a paid service is not activated within the committed onboarding timeline from our side, you are eligible for a full refund of the amount paid for the undelivered service.",
    },
    {
        title: "5. How to Request a Refund",
        body: "Write to us from your registered email or WhatsApp with your business name, registered phone number and payment reference. Eligible refunds are processed to the original payment method within 7–10 working days after approval.",
    },
    {
        title: "6. Contact",
        body: "For refund or cancellation requests, reach us via the Contact page or on WhatsApp at " + COMPANY.phoneDisplay + ".",
    },
];

export default function Refund() {
    return (
        <div className="mx-auto max-w-4xl px-4 py-20 sm:px-6 lg:py-24" data-testid="refund-page">
            <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-cyan-400">Legal</p>
            <h1 className="mt-3 font-display text-4xl font-extrabold text-white" data-testid="refund-heading">Refund & Cancellation Policy</h1>
            <p className="mt-3 text-sm text-slate-500">Last updated: October 2026 · {COMPANY.legal}</p>
            <div className="mt-10 space-y-8">
                {SECTIONS.map((s) => (
                    <section key={s.title} data-testid={`refund-section-${s.title.split(".")[0]}`}>
                        <h2 className="font-display text-lg font-bold text-white">{s.title}</h2>
                        <p className="mt-2.5 text-sm leading-relaxed text-slate-400">{s.body}</p>
                    </section>
                ))}
            </div>
        </div>
    );
}
